import to from 'await-to-js';
import { generateQueryParameter } from 'utils/generateQueryParameter';
import { api } from '.';

import { resultEstimateAdaptor, sendEstimateAdaptor } from 'adaptors/estimate/estimate';
import { planUsageAdaptor } from 'adaptors/plans/plan-usage.adaptor';
import { getShopInfoAdaptor } from 'adaptors/shop/shop-info';
import {
  cancelCampaign,
  deactivateCampaign,
  estimateRequest,
  getEstimateProducts as orvalGetEstimateProducts,
  updateCampaign,
  previewCampaignCoverage as orvalPreviewCampaignCoverage,
  previewCampaignCoverageProducts as orvalPreviewCampaignCoverageProducts,
  getCampaignCoverage as orvalGetCampaignCoverage,
  getCampaignCoverageProducts as orvalGetCampaignCoverageProducts,
  resolveProduct as orvalResolveProduct,
  getCampaignOverlaps as orvalGetCampaignOverlaps,
  excludeCampaignProducts as orvalExcludeCampaignProducts,
} from 'rest/dist/gen/api/campaigns/campaigns';
import { sendCoveragePreviewAdaptor } from 'adaptors/campaign/save.adaptor';
import { fetchInstance } from 'rest/dist/utils/fetchInstance';
import { getPlanUsage } from 'rest/dist/gen/api/pricing/pricing';
import { getShopInfo as ApiGetShopInfo, getShopStorage } from 'rest/dist/gen/api/shops/shops';

export const getShopInfo = async (callback) => {
  const [[error, response], [, responseonboard]] = await Promise.all([
    to(ApiGetShopInfo()),
    to(getShopStorage()),
  ]);
  if (response) {
    const data = { data: getShopInfoAdaptor(response.data, responseonboard?.data) };

    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getNotifications = async (filter, callback) => {
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getNotifications(params));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const setNotificationClose = async (data, callback) => {
  const [error, response] = await to(api.setNotificationClose(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const setNotificationView = async (data, callback) => {
  const [error, response] = await to(api.setNotificationView(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getShopPlanInfo = async (callback) => {
  const [error, response] = await to(api.getShopPlanInfo());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getPermission = async (callback) => {
  const [error, response] = await to(getPlanUsage());
  if (response) {
    const data = planUsageAdaptor(response);
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const createAuction = async (values, callback) => {
  const [error, response] = await to(api.createAuction(values));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const deleteAuctions = async (values, callback) => {
  const [error, response] = await to(api.deleteAuctions(values));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const updateCampaignEndDate = async (values, callback) => {
  const [error, response] = await to(
    updateCampaign(values.auctionId, { endAt: values.endDate, status: 'active',hasProductCountdown:values.hasProductCountdown,conflictManagementTempModel:values.conflictManagementTempModel,bogoConflictedProductsToRemove:values.bogoConflictedProductsToRemove }),
  );

  if (values.isActive === false) {
    await to(deactivateCampaign(values.auctionId));
  }
  if (response) {
    const data = { date: response };
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const archiveAuctions = async (values, callback) => {
  const [error, response] = await to(api.archiveAuctions(values));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const unArchiveAuctions = async (values, callback) => {
  const [error, response] = await to(api.unArchiveAuctions(values));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getEstimatedProductsRequestStatus = async (filter, callback) => {
  // const params = await generateQueryParameter(filter);
  const [error, response] = await to(orvalGetEstimateProducts(filter));
  if (response) {
    const data = resultEstimateAdaptor(response);
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getOption = async (filter, callback) => {
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getOption(params));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getPlans = async (callback) => {
  const [error, response] = await to(api.getPlans());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getPlansWithDiscount = async (filter, callback) => {
  var filtercode = filter.discountCode;
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getPlansWithDiscount(filtercode));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getShopSetting = async (callback) => {
  const [error, response] = await to(api.getShopSetting());
  if (response) {
    const data = response.data;
    callback(response.data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const saveShopSetting = async (data, callback) => {
  const [error, response] = await to(api.saveShopSetting(data));
  if (response) {
    const data = response.data;
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const callSaveShopSetting = async (data, callback) => {
  const [error, response] = await to(api.saveShopSetting(data));

  if (error || response.error) {
    return {
      success: false,
      data: error || response,
    };
  }

  if (response) {
    const data = response.data;
    return {
      success: true,
      data,
    };
  }
};
export const wasItHelpful = async (data, callback) => {
  const [error, response] = await to(api.wasItHelpful(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const sendSupportEmail = async (data, callback) => {
  const [error, response] = await to(api.sendSupportEmail(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getFaqList = async (callback) => {
  const [error, response] = await to(api.getFaqList());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const campaignForceStop = async (id, callback) => {
  const [error, response] = await to(cancelCampaign(id));
  if (response) {
    const data = response.data;
    callback(true, {});
  }
  if (error) {
    callback(false, error);
  }
};
export const getTopFiveCampaign = async (callback) => {
  const [error, response] = await to(api.getTopFiveCampaign());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getEstimateProducts = async (values, callback) => {
  const payload = sendEstimateAdaptor(values);
  const [error, response] = await to(estimateRequest(payload));
  if (response) {
    const data = response;
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};

// Campaign precedence: draft coverage preview, unsaved/being-edited campaign
// arbitrated against every other campaign's live winners. Uses a dedicated
// minimal scope-only adaptor (NOT saveCampaignAdaptor — that one assumes
// every auction* array is already populated and throws on a still-settling
// mid-edit form state, which silently killed every preview after the first
// one; see sendCoveragePreviewAdaptor's own comment).
export const previewCampaignCoverage = async (campaign, callback) => {
  let payload;
  try {
    payload = sendCoveragePreviewAdaptor(campaign);
  } catch (e) {
    console.error('[previewCampaignCoverage] adaptor threw, skipping preview', e);
    callback(false, e);
    return;
  }
  const [error, response] = await to(orvalPreviewCampaignCoverage(payload));
  if (response) callback(true, response.data);
  if (error) {
    console.error('[previewCampaignCoverage] request failed', error);
    callback(false, error);
  }
};

// Draft-preview counterpart of getCampaignCoverageProducts (below) — for a
// campaign with no id (or an id that hasn't been through processing yet),
// there's no saved coverage doc to page through, so this re-sends the whole
// draft scope (same adaptor previewCampaignCoverage uses) plus which other
// campaign's claim to list against.
export const previewCampaignCoverageProducts = async (campaign, byCampaignId, cursor, limit, callback) => {
  let payload;
  try {
    payload = { ...sendCoveragePreviewAdaptor(campaign), byCampaignId, cursor, limit };
  } catch (e) {
    console.error('[previewCampaignCoverageProducts] adaptor threw, skipping', e);
    callback(false, e);
    return;
  }
  const [error, response] = await to(orvalPreviewCampaignCoverageProducts(payload));
  if (response) callback(true, response.data);
  if (error) {
    console.error('[previewCampaignCoverageProducts] request failed', error);
    callback(false, error);
  }
};

export const getCampaignCoverage = async (campaignId, callback) => {
  const [error, response] = await to(orvalGetCampaignCoverage(campaignId));
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

export const getCampaignCoverageProducts = async (campaignId, params, callback) => {
  const [error, response] = await to(orvalGetCampaignCoverageProducts(campaignId, params));
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

export const resolveProductPrecedence = async (productId, callback) => {
  const [error, response] = await to(orvalResolveProduct({ productId }));
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

export const getCampaignOverlaps = async (callback) => {
  const [error, response] = await to(orvalGetCampaignOverlaps());
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

// Pairs of live bundles that share products (informational, sharing is allowed).
export const getBundleSharing = async (callback) => {
  const [error, response] = await to(fetchInstance({ url: '/api/campaigns/overlaps/bundle-sharing', method: 'get' }));
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

// Bundles may share products (Decision 2): read-only report of which other live bundles use
// the same products as this draft. Called straight through fetchInstance, like the generated client.
export const previewBundleSharing = async (campaign, callback) => {
  let payload;
  try {
    payload = sendCoveragePreviewAdaptor(campaign);
  } catch (e) {
    callback(false, e);
    return;
  }
  const [error, response] = await to(
    fetchInstance({
      url: '/api/campaigns/bundle/sharing',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: { ...payload, id: campaign?.id || undefined, name: campaign?.name },
    })
  );
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

// "Limit to one set": keep products out of one bundle (adds them to its slot exclusions).
export const excludeBundleProducts = async (campaignId, productIds, callback) => {
  const [error, response] = await to(
    fetchInstance({
      url: `/api/campaigns/${campaignId}/bundle/exclude-products`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: { productIds },
    })
  );
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

export const excludeCampaignProducts = async (campaignId, body, callback) => {
  const [error, response] = await to(orvalExcludeCampaignProducts(campaignId, body));
  if (response) callback(true, response.data);
  if (error) callback(false, error);
};

// A campaign that stays Queued too long: re-enqueue it once (Retry) or take it out of the queue so it
// can be edited again (Cancel). Called straight through fetchInstance, like previewBundleSharing.
export const retryQueuedCampaign = async (campaignId, callback) => {
  const [error, response] = await to(
    fetchInstance({ url: `/api/campaigns/${campaignId}/queued/retry`, method: 'post' })
  );
  if (response) callback(true, response.data?.data ?? response.data);
  if (error) callback(false, error);
};

export const cancelQueuedCampaign = async (campaignId, callback) => {
  const [error, response] = await to(
    fetchInstance({ url: `/api/campaigns/${campaignId}/queued/cancel`, method: 'post' })
  );
  if (response) callback(true, response.data?.data ?? response.data);
  if (error) callback(false, error);
};
